<div
  [class.hover:bg-proffeo-surface-muted]="!isLocationDisabled()"
  [class.cursor-not-allowed]="isLocationDisabled()"
  class="flex items-center justify-between gap-3 rounded-lg"
>
  <div class="flex items-center">
    @if (sublocationsVisible) {
      <mat-icon
        (click)="toggleSublocations(); $event.stopPropagation()"
        fontIcon="keyboard_arrow_up"
        class="icon-muted cursor-pointer icon-xl mr-2"
      />
    }

    @if (!sublocationsVisible && location().childrenCount() > 0) {
      <mat-icon
        (click)="toggleSublocations(); $event.stopPropagation()"
        fontIcon="keyboard_arrow_down"
        class="icon-muted cursor-pointer icon-xl mr-2"
      />
    }
    <mat-radio-button
      (change)="selectLocation(location())"
      [checked]="location().id === selectedLocation()?.id"
      [disabled]="isLocationDisabled()"
      [value]="location().id"
      class="mr-2 shrink-0"
    />
    <span
      [class.opacity-50]="isLocationDisabled()"
      [class.font-semibold]="isPartOfSelectedLocation(location())"
    >
      {{ location().name }}
    </span>
  </div>
  <div class="flex items-center">
    <div>
      @if (location()?.childrenCount() > 0) {
        <button
          (click)="toggleSublocations()"
          [attr.aria-expanded]="sublocationsVisible"
          [class.proffeo-ui-tree-count-chip-active]="sublocationsVisible"
          type="button"
          class="proffeo-ui-tree-count-chip"
        >
          <mat-icon
            fontIcon="subdirectory_arrow_right"
            class="icon-sm opacity-50"
          />
          <span>{{ location()?.childrenCount() }}</span>
        </button>
      }
    </div>
  </div>
</div>
@if (sublocationsVisible) {
  <div class="pl-[28px]">
    @for (location of locationChildren(); track location?.id) {
      <div class="pb-2">
        <proffeo-select-location-list-item
          (locationSelected)="selectLocation($event)"
          [excludedLocationIds]="excludedLocationIds()"
          [location]="location"
          [selectedLocation]="selectedLocation()"
        ></proffeo-select-location-list-item>
      </div>
    }
  </div>
}
